import React, { useEffect, useMemo, useRef, useState } from 'react';
import { internshipAPI } from '../../services/api';
import LetterDocument from './LetterDocument';

const company = {
  name: 'Growmore IT Services',
  address: 'Mangalmurti Apartment, Near IT Park, Godoli, Satara, Maharashtra',
  email: 'info@growmoreitservices.com',
  phone: '+91 7350695792 / +91 9022487236',
  signatory: 'Vivek Kalaskar',
  signatory_title: 'Founder'
};

const DemoCertificate = ({ type = 'completion', roleTitle, formats: propFormats }) => {
  const slotRef = useRef(null);
  const [scale, setScale] = useState(0.45);
  const [formats, setFormats] = useState(propFormats || null);

  useEffect(() => {
    if (propFormats) {
      setFormats(propFormats);
      return;
    }
    internshipAPI.formats()
      .then(({ data }) => {
        if (data?.formats) {
          setFormats(data.formats);
        }
      })
      .catch(() => {});
  }, [propFormats]);

  useEffect(() => {
    const el = slotRef.current;
    if (!el) return undefined;
    const measure = () => {
      const w = el.clientWidth;
      if (w < 80) return;
      setScale(Math.max(0.34, Math.min(w / 794, 1)));
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const activeFormat = formats?.[type] || null;

  const letter = useMemo(() => {
    const isOffer = type === 'offer';
    const verifyUrl = 'https://growmoreitservices.com/verify/GMIS-CMP-DEMO';
    return {
      letter_code: isOffer ? 'GMIS-OFR-DEMO' : 'GMIS-CMP-DEMO',
      type: isOffer ? 'offer' : 'completion',
      intern_code: 'GMIS-INT-DEMO',
      intern_name: 'Aarav Patil',
      college: 'Satara Engineering College, Satara',
      date_of_birth: '2004-01-01',
      email: 'aarav.patil@example.com',
      phone: '+91 98765 43210',
      role_title: roleTitle || 'Full Stack Developer',
      join_date: '2026-04-01',
      complete_date: '2026-04-30',
      issued_at: isOffer ? '2026-04-01' : '2026-04-30',
      intern_signed: !isOffer,
      verify_url: verifyUrl,
      qr_url: isOffer ? null : `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(verifyUrl)}`,
      company: {
        ...company,
        signatory: activeFormat?.signatory || company.signatory,
        signatory_title: activeFormat?.signatory_title || company.signatory_title
      },
      format: activeFormat || {},
      weeks_total: 4
    };
  }, [type, roleTitle, activeFormat]);

  useEffect(() => {
    const block = (event) => event.preventDefault();
    const onKey = (event) => {
      if (event.key === 'PrintScreen') {
        event.preventDefault();
      }
      if ((event.ctrlKey || event.metaKey) && ['p', 's', 'c'].includes(event.key.toLowerCase())) {
        event.preventDefault();
      }
    };
    const onPrint = () => {
      document.body.classList.add('demo-print-block');
    };
    document.addEventListener('contextmenu', block);
    document.addEventListener('copy', block);
    document.addEventListener('cut', block);
    document.addEventListener('dragstart', block);
    document.addEventListener('keydown', onKey);
    window.addEventListener('beforeprint', onPrint);
    return () => {
      document.removeEventListener('contextmenu', block);
      document.removeEventListener('copy', block);
      document.removeEventListener('cut', block);
      document.removeEventListener('dragstart', block);
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('beforeprint', onPrint);
      document.body.classList.remove('demo-print-block');
    };
  }, []);

  return (
    <div className="demo-cert-guard relative rounded-2xl sm:rounded-3xl overflow-hidden border border-[#0b3a5b]/15 bg-[#f4efe4] min-w-0">
      <div className="demo-watermark" aria-hidden>
        <span>Sample · Not for download · Growmore</span>
      </div>
      <div ref={slotRef} className="relative z-10 w-full overflow-hidden px-2 py-2 sm:px-4 sm:py-4">
        <div className="mx-auto" style={{ width: 794 * scale, height: 1123 * scale }}>
          <div
            className="pointer-events-none select-none origin-top-left"
            style={{ width: 794, height: 1123, transform: `scale(${scale})` }}
          >
            <LetterDocument letter={letter} />
          </div>
        </div>
      </div>
      <p className="relative z-30 text-center text-[11px] font-semibold text-[#0b3a5b] bg-[#0b3a5b]/5 py-2.5 sm:py-3 px-3 sm:px-4 border-t border-[#0b3a5b]/10 leading-5">
        Demo preview only. Download, print and copy are disabled. Official letters are issued after enrolment and task approval.
      </p>
    </div>
  );
};

export default DemoCertificate;
